import cache from './cache.js';
import slugify from './slugify.js';
import testUserAgent from './testUserAgent.js';
import osVersions from './osVersions.js';
import operatingSystems from './operatingSystems.json';

export default cache('getOperatingSystem', function getOperatingSystem() {
  const [name = 'unknown'] = testUserAgent(operatingSystems);

  // see if we have an os version test available
  const slug = slugify(name);
  const version = osVersions?.[slug]?.() ?? '';

  return {
    name,
    version,
  };
});
